import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Middle_Ages_-_African_Kingdoms_e.g._Mali_Ghana.png';

function HistoryPageAfrica() {
  return (
    <TopicPage
      topicKey="African Kingdoms (e.g., Mali, Ghana)"
      title="History: African Kingdoms"
      backgroundImage={bg}
      startRoute="/History-African-Kingdoms-Go"
      scrollLabels={[
        "The Kingdom of Ghana",
        "Mali and Mansa Musa",
        "Trade and Culture",
      ]}
              backRoute="/history-Middle-Ages"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageAfrica;   